import { CreateTagDTO } from '../models/tag';
import apiClient from './api';

export const getAllTags = async () => {
    const response = await apiClient.get('/tag');
    return response.data;
}

export const createTag = async (tag: CreateTagDTO) => {
    const response = await apiClient.post('/tag', tag);
    return response.data;
}

export const updateTag = async (tagID: number, tag: CreateTagDTO) => {
    const response = await apiClient.put(`/tag/${tagID}`, tag);
    return response.data;
}

export const deleteTag = async (tagID: number) => {
    const response = await apiClient.delete(`/tag/${tagID}`);
    return response.data;
}

